module.exports = __webpack_public_path__ + "img/gobierno-abierto.7bdf0262.png";